import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getDateTimeString, getSmallId } from "../../utils/helpers";
import {showClientBlockModal} from "../../services/admin/action-creators";

const AdminFileRequest = () => {
    const dispatch = useDispatch();
    const { fileRequests } = useSelector((state) => state.file);

    const { chosenId } = useSelector((state) => state.admin);

    const handleBlockClick =  () => {
       dispatch(showClientBlockModal());
    };

    const filterUsers = () => {
        const result = Object.keys(fileRequests)
            .filter(key => fileRequests[key]._id === chosenId);
        return result;
    };

    if(!Object.keys(fileRequests).length) {
        return (<></>);
    }

    return(
        <div>
            <div className = "clients_content_section">
                <div className="table_clients">
                    <div className="t_row t_header">
                        <div className="tc_center tc_id">User ID</div>
                        <div className="tc_email">Email</div>
                        <div className="tc_checks">Checks</div>
                        <div className="tc_center tc_payments">Payments</div>
                        <div className="tc_center tc_date">Last Signin Date</div>
                        <div className="tc_center tc_date">Registration Date</div>
                        <div className="tc_center tc_block">Block Acc</div>
                        <div className="tc_center tc_ip">IP</div>
                    </div>


                    {filterUsers()
                        .map((key, index) => (
                            <div className="t_row" key={key}>
                                <div className="tc_center tc_id"><div>{getSmallId(fileRequests[key]._id)}</div></div>
                                <div className="tc_email"><div>{fileRequests[key].email}</div></div>
                                <div className="tc_checks"><div>{fileRequests[key].credits}</div></div>
                                <div className="tc_center tc_payments"><div>{fileRequests[key].credits}</div></div>
                                <div className="tc_center tc_date"><div>{getDateTimeString(fileRequests[key].lastSignInDate)}</div></div>
                                <div className="tc_center tc_date"><div>{getDateTimeString(fileRequests[key].createdAt)}</div></div>
                                <div className="tc_click tc_center tc_block" onClick={handleBlockClick}>
                                    <img src={ `images/clients/circle-${fileRequests[key].blockAccount ? "cancel" : "ok"}.svg`} alt=""/>
                                </div>
                                <div className="tc_center tc_ip">{fileRequests[key].registrationIP}</div>
                            </div>
                        ))}
                </div>

            </div>
            <div className = "clients_content_section">
                <div className="clients_menu">
                    <h3>File Help Requests</h3>
                    <div className="flex-row flex-center">
                        <div>User ID: {getSmallId(chosenId)}</div>
                    </div>
                </div>
                <div className="line"></div>
                <div className="table_clients">
                    <div className="t_row t_header">
                        <div className="tc_center tc_id">File ID</div>
                        <div className="tc_center tc_email">Name</div>
                        <div className="tc_center tc_email">Url</div>
                        <div className="tc_center tc_email">Error</div>
                        <div className="tc_center tc_date">Uploaded At</div>
                    </div>


                    {fileRequests[chosenId].fileRequests
                        .map((fr) => (
                            <div className="t_row" key={fr._id}>
                                <div className="tc_center tc_id"><div>{getSmallId(fr._id)}</div></div>
                                <div className="tc_center tc_email"><div>{fr.fileName}</div></div>
                                <div className="tc_center tc_email"><div>{fr.signedUrl.split('?')[0]}</div></div>
                                <div className="tc_center tc_email"><div>{fr.failed.message}</div></div>
                                <div className="tc_center tc_date"><div>{getDateTimeString(fr.createdAt)}</div></div>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    )
};

export default AdminFileRequest;